import Icon, { IconType } from 'components/Icon';
import * as S from './styles';

interface CollapsibleSectionProps {
	label: string;
	isCollapsed?: boolean;
	onToggle?: () => void;
	children: React.ReactNode;
	collapsible?: boolean;
}

const CollapsibleSection = ({
	label,
	isCollapsed = false,
	onToggle,
	children,
	collapsible = true,
}: CollapsibleSectionProps) => {
	const effectiveCollapsed = collapsible ? isCollapsed : false;

	return (
		<>
			<S.Header
				onClick={collapsible ? onToggle : undefined}
				aria-expanded={!effectiveCollapsed}
				$collapsible={collapsible}
			>
				{collapsible && (
					<S.Chevron $isCollapsed={isCollapsed}>
						<Icon type={IconType.FILLED_ARROW_RIGHT} width={10} height={10} />
					</S.Chevron>
				)}
				{label}
			</S.Header>
			<S.Body $isCollapsed={effectiveCollapsed}>
				<div>{children}</div>
			</S.Body>
		</>
	);
};

export default CollapsibleSection;
